// src/components/button/button.tsx
import { CircleLoader } from "@cat-home-experts/mortar-iconography-web/CircleLoader";
import { buttonStyles } from "./button.styles.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
var Button = ({
  as,
  ref,
  variant = "default",
  size = "sm",
  iconOnly,
  className,
  children,
  startContent,
  endContent,
  loading,
  loadingText,
  disabled,
  type = "button",
  href,
  ...componentProps
}) => {
  const style = buttonStyles({ variant, size, iconOnly });
  const Component = as ? as : href ? "a" : "button";
  const isDisabled = !!loading || disabled;
  const customComponentProps = Component === "button" ? { ...componentProps, type, disabled: isDisabled } : { ...componentProps, href };
  const innerContent = !loading ? children : loadingText ? loadingText : children;
  return (
    // @ts-expect-error - as type issues
    /* @__PURE__ */ jsxs(
      Component,
      {
        ref,
        ...customComponentProps,
        className: style.base({ className }),
        "data-loading": loading ? true : void 0,
        children: [
          loading && /* @__PURE__ */ jsx("span", { className: style.loadingContainer(), children: /* @__PURE__ */ jsx(
            CircleLoader,
            {
              role: "presentation",
              className: "animate-spin duration-75",
              size: 20,
              color: "#fff"
            }
          ) }),
          !loading && startContent && /* @__PURE__ */ jsx("span", { className: style.contentStartWrapper(), children: startContent }),
          innerContent,
          endContent && /* @__PURE__ */ jsx("span", { className: style.contentEndWrapper(), children: endContent })
        ]
      }
    )
  );
};
export {
  Button
};
